import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getCoachReassignedStudentGroups, updateStudentGroupAudit } from '@/lib/api-calls.js';
import { StudentGroupAuditWithClassTimeLevel } from '@airreading/common/data';
import { Checkbox } from '@/components/ui/checkbox.js';

export interface CountAsReassignedToggleProps {
  studentGroupAudit: StudentGroupAuditWithClassTimeLevel;
}

export const CountAsReassignedToggle = ({ studentGroupAudit }: CountAsReassignedToggleProps) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: updateStudentGroupAudit,
    onSuccess: () => {
      if (studentGroupAudit.substituteCoachId) {
        queryClient.invalidateQueries(getCoachReassignedStudentGroups(studentGroupAudit.substituteCoachId));
      }
    },
  });

  const handleCheckedChange = (checked: boolean | 'indeterminate') => {
    mutate({ id: studentGroupAudit.id, data: { reassigned: Boolean(checked) } });
  };

  return <Checkbox checked={studentGroupAudit.reassigned} disabled={isPending} onCheckedChange={handleCheckedChange} />;
};
